<template>
    <div id="calendario">
        <div class="header">
            <div style="display: flex; flex-direction: column; align-items: start; width: 70%;">
                <v-btn @click="$emit('close-item')" variant="text" color="inherit"><img
                        src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
                        alt=""></v-btn>
                <p class="submenu-title">Calendário</p>
            </div>


        </div>

        <div>
            <VCalendar @dayclick="(params) => dayClicked(params)" locale="pt" :attributes="calendarAttributes"
                style="margin-top: 5%;" borderless />

            <v-card v-if="loaded" class="mx-auto" max-width="300" >
                <ul style="list-style: none;">
                    <p v-if="filteredAgendamento.length > 0" style="font-weight: bolder; margin-bottom: 3%;">Agendamentos</p>
                    <li style="border: 1px solid #E8E8E8; display: flex; padding: 10px; flex-direction: column;  border-radius: 8px; margin-bottom: 10px; width: 90%; margin-left: 5%;"
                        v-for="event in filteredAgendamento" :key="event">

                        <div style="display: flex; flex-direction: row;">
                            <div class="date-wrapper">
                                <p class="day">{{ getMonthName(event['DATA_AGENDAMENTO']) }}</p>
                                <p class="day-number">{{ getDay(event['DATA_AGENDAMENTO']) }}</p>
                            </div>

                            <div style="text-align: start; margin-left: 3%; width: 160px;">
                                <p style="margin-left: 10px; font-size: 14px; padding: 0; margin: 0; margin-bottom: 2%;">{{ event['MSG_AGENDAMENTO'] }}</p>
                                <div style="display: flex; align-items: center">
                                    <img src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/dd2fbbb0-014e-4d4b-a8ed-bdac97fd652c.svg"
                                        alt="">
                                    <span style="font-size: 12px;">{{ event['HORA_AGENDAMENTO'] }}</span>
                                </div>
                            </div>

                        </div>
                    </li>
                    <p v-if="filteredEvents.length > 0" style="font-weight: bolder; margin-bottom: 3%;">Eventos</p>
                    <li style="border: 1px solid #E8E8E8; display: flex; padding: 10px; flex-direction: column;  border-radius: 8px; margin-bottom: 10px; width: 90%; margin-left: 5%;"
                        v-for="(event, i) in filteredEvents" :key="i">

                        <div style="display: flex; flex-direction: row;">
                            <div class="date-wrapper">
                                <p class="day">{{ getMonthName(event.date) }}</p>
                                <p class="day-number">{{ getDay(event.date) }}</p>
                            </div>

                            <div style="text-align: start; margin-left: 3%; width: 160px;">
                                <p style="margin-left: 10px; font-size: 14px; padding: 0; margin: 0; margin-bottom: 2%;">{{ event.name }}</p>
                                <div style="display: flex; align-items: center">
                                    <img src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/dd2fbbb0-014e-4d4b-a8ed-bdac97fd652c.svg"
                                        alt="">
                                    <span style="font-size: 12px;">{{ event.start_at }} - {{ event.end_at }}</span>
                                    <img style="margin-left: 5%;" src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/52dd6eb8-c587-49ed-a206-71f0bee9bee2.svg"
                                        alt="">
                                    <span style="font-size: 12px;">{{ event.modality.charAt(0).toUpperCase() + event.modality.slice(1) }}</span>
                                </div>
                            </div>

                        </div>

                        <div v-if="event.bcsIsSubscribed"
                            style="display: flex; margin: 10px 0 0; flex-direction: row; align-items: center; justify-content: space-between; width: 100%;">
                            <v-btn width="48%" height="30px" style="font-size: 11px;" variant="tonal" color="#EB3030"
                                class="text-none"
                                @click="showEvent = true; eventId = event._id; enrollmentId = event.enrollment_id; optionSelected = 'unsubscribe'">Cancelar
                                presença</v-btn>
                            <v-btn width="48%" height="30px" style="font-size: 11px;" class="text-none" color="#370053"
                                @click="showEvent = true; eventId = event._id; enrollmentId = event.enrollment_id; optionSelected = 'show'">Ver
                                evento</v-btn>
                        </div>

                        <div v-else
                            style="display: flex; margin: 10px 0 0; flex-direction: row; align-items: center; justify-content: space-between; width: 100%;">
                            <v-btn width="48%" height="30px" style="font-size: 11px;" variant="tonal" color="#660099"
                                class="text-none"
                                @click="showEvent = true; optionSelected = 'show'; eventId = event._id; enrollmentId = event.enrollment_id">Ver
                                evento</v-btn>
                            <v-btn width="48%" height="30px"
                                @click="showEvent = true; optionSelected = 'subscribe'; eventId = event._id; enrollmentId = event.enrollment_id"
                                style="font-size: 11px;" class="text-none" color="#660099">Confirmar Presença</v-btn>
                        </div>
                    </li>
                </ul>
            </v-card>
            <v-progress-circular
                v-else
                indeterminate
                color="#BC4AFF"
                :size="70"
                :width="7"
                style=""
            ></v-progress-circular>
        </div>
    </div>

    <ModalEvento @close-modal="showEvent = false" :enrollment-id="enrollmentId" v-if="showEvent" :option="optionSelected"
        :event-id="eventId" @refresh-calendar="reRender()"/>
</template>

<script setup>
import { defineEmits, onMounted, ref } from 'vue';
import requestApi from '@/utils/requestApi'
import ModalEvento from './ModalEvento.vue';
// import ModalEvento from './ModalEvento.vue';
import { useGlobalStateStore } from '../../../../store';

const globalStateStore = useGlobalStateStore();

defineEmits(["close-item", "refresh-calendar"])

const events = ref([])
const filteredEvents = ref([])
const filteredAgendamento = ref([])
const loaded = ref(false)
const responseAgendamento = ref([])

const showEvent = ref(false)
const eventId = ref('')
const optionSelected = ref('')
const enrollmentId = ref(null)

const calendarAttributes = ref([
    {
        dot: true,
        dates: []
    },
    {
        highlight: true,
        dates: null
    }
])

function dayClicked(params) {
    if (params.date != calendarAttributes.value[1].dates) {
        calendarAttributes.value[1].dates = params.date
        filteredEvents.value = []
        filteredAgendamento.value = []
        for (const eventItem of events.value) {
            if (compareDates(eventItem.date, params.date)) {
                filteredEvents.value.push(eventItem)
            }
        }
        for (const eventItem of responseAgendamento.value) {
            if (compareDates(eventItem['DATA_AGENDAMENTO'], params.date)) {
                filteredAgendamento.value.push(eventItem)
            }
        }
    } else {
        calendarAttributes.value[1].dates = []
    }
}

onMounted(async () => {
    await getEnrollments()
})

async function reRender() {
    await getEnrollments()
}

async function getEnrollments() {
    let verifySubscription = null
    events.value = []
    responseAgendamento.value = []
    calendarAttributes.value[1].dates = []
    calendarAttributes.value[0].dates = []
    filteredEvents.value = []
    loaded.value = false

    const response = await requestApi(
        {
            url: `/v2/gatherings`,
            method: 'get',
            headers: {
                BCS: globalStateStore.uuid,
                'Content-Type': 'application/json',
            }
        }
    )

    await requestApi(
        {
            url: `/v2/bcs_enrollments`,
            method: 'get',
            headers: {
                BCS: globalStateStore.uuid,
                'Content-Type': 'application/json',
            },
        }
    ).then(response => {
        verifySubscription = response.data
    }).catch((error) => {
        if (error.response.status === 404) {
            verifySubscription = null
            console.log(error)
        }
    })

    await requestApi(
        {
            url: `v2/vivo_integration/video/${process.env.VUE_APP_VIDEO_ID}/user/${window.ovmConfig.env['CPF']}/date_msg_scheduling`,
            method: 'get',
            headers: {
                BCS: globalStateStore.uuid,
                'Content-Type': 'application/json',
            },
        }
    ).then(response => {
        responseAgendamento.value.push(response.data)
    }).catch((error) => {
        if (error.response.status === 404) {
            console.log(error)
        }
    })

    for (let key in response.data) {
        if (response.data[key].is_limited === true) {
            if (response.data[key].enrollments_count < response.data[key].limitation) {
                events.value.push(response.data[key])
            }
        } else {
            events.value.push(response.data[key])
        }
    }
    if (verifySubscription !== null) {
        compareEvents(events.value, verifySubscription)
    }
    loadCalendarDates()
    loaded.value = true
}

function getDay(key) {
    let dateArray = key.split("-");
    let year = dateArray[0];
    let month = dateArray[1] - 1;
    let date = dateArray[2].slice(0, 2);
    let _entryDate = new Date(year, month, date);
    return _entryDate.getDate();
}

function getMonthName(date) {
    const monthNames = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];
    return monthNames[new Date(date).getMonth()].substr(0, 3);
}

function loadCalendarDates() {
    for (const event of events.value) {
        const { year, month, day } = convertDate(event.date)
        calendarAttributes.value[0].dates.push(new Date(year, month, day))
    }
    if (responseAgendamento.value.length > 0) {
        const { year, month, day } = convertDate(responseAgendamento.value[0]['DATA_AGENDAMENTO'])
        calendarAttributes.value[0].dates.push(new Date(year, month, day))
    }
}

function convertDate(date) {
    const originalDate = new Date(date)

    const year = originalDate.getFullYear();
    const month = originalDate.getMonth();
    const day = originalDate.getDate() + 1;


    return { year, month, day };
}

function compareDates(dateString1, dateString2) {
    // Convert strings to Date objects
    const date1 = new Date(dateString1);
    const date2 = new Date(dateString2);

    // Get day, month, and year from both dates
    const day1 = date1.getDate() + 1;
    const month1 = date1.getMonth();
    const year1 = date1.getFullYear();

    const day2 = date2.getDate();
    const month2 = date2.getMonth();
    const year2 = date2.getFullYear();

    // Compare days, months, and years
    const areEqual =
        day1 === day2 &&
        month1 === month2 &&
        year1 === year2;

    return areEqual;
}

function compareEvents(allEvents, eventsBCS) {
    for (const event of allEvents) {
        for (const event2 of eventsBCS) {
            if (event._id == event2.id) {
                event.bcsIsSubscribed = true;
                event.enrollment_id = event2.enrollment_id;
                break;
            } else {
                event.bcsIsSubscribed = false
            }
        }
    }
}

</script>

<style scoped>
#calendario {
    width: 100%;
    height: 90%;
    background: #fff;
    position: absolute;
    top: 0;
    z-index: 1;
    overflow-y: auto;
}

.header {
    height: 25%;
    background-color: #BC4AFF;
    display: flex;
}

.submenu-title {
    color: white;
    margin-top: 15%;
    font-size: 20px;
    text-align: start;
    margin-left: 10%;
}

.icon-wrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F6E7FF;
    border-radius: 50%;
    margin-right: 20px;
}

.date-wrapper {
    border-radius: 8px;
    border: 1px solid var(--eccdff, #ECCDFF);
    background: var(--faf-2-ff, #FAF2FF);
    width: 55px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-right: 10px;
}

.day,
.day-number {
    font-size: 14px;
    color: #BC4AFF;
}

.day-number {
    font-weight: bold;
    font-size: 18px;
    color: #370053;
}
</style>